import { useEffect } from 'react';
import { useCompany } from 'hooks';

const DetectRefresh = () => {
  const { refreshAll } = useCompany();

  useEffect(() => {
    if (performance.navigation.type === 1) {
     // console.log('Page was refreshed (F5 or Ctrl+R)');
      // refreshAll();
    } else {
      console.log('Not a refresh (normal navigation)');
    }
  }, []);

  return null; // No UI
};

export default DetectRefresh;
